"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddValuesToSeveralNodes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const edit_attribute_mutation_1 = require("../../attributes/edit-attribute.mutation");
const product_tree_nodes_1 = require("../../product-tree-nodes");
const useAddValuesToSeveralNodes = () => {
    const [editAttributeMutation] = (0, react_2.useMutation)(edit_attribute_mutation_1.EDIT_ATTRIBUTE);
    const addValuesToSeveralNodes = (0, react_1.useCallback)((attributes_1, treeNodeIds_1, ...args_1) => __awaiter(void 0, [attributes_1, treeNodeIds_1, ...args_1], void 0, function* (attributes, treeNodeIds, options = {}) {
        const variableList = [];
        for (const attribute of attributes) {
            for (const treeNodeId of treeNodeIds) {
                variableList.push([attribute, treeNodeId]);
            }
        }
        const promises = variableList.map(([{ name: label, values, }, treeNodeId]) => new Promise((resolve, reject) => {
            void editAttributeMutation({
                variables: {
                    productLabelValidation: Object.assign({ label, productTreeNode: treeNodeId, addAllowedValues: values.map(({ name, description }) => ({ value: name, description: description || null })), clientMutationId: '', includeDescendants: false, includeAncestors: false }, options),
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                },
                onError: (error) => reject(new Error(error.message)),
                onCompleted: (data) => resolve(data.editProductLabelValidation),
            });
        }));
        const results = yield Promise.all(promises);
        const errors = results.filter(({ error }) => error).map(({ error }) => error);
        const errorMessage = errors.join(', ');
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        const updatedPaths = (0, product_tree_nodes_1.getTreeNodePaths)(results.map(({ productTreeNode }) => productTreeNode));
        return updatedPaths;
    }), [editAttributeMutation]);
    return {
        addValuesToSeveralNodes,
    };
};
exports.useAddValuesToSeveralNodes = useAddValuesToSeveralNodes;
